export enum InfoResultType {
  Series,
  Question,
  UserResult,
  CourseResult,
}
